import { v4 as uuidv4 } from "uuid";
import {
    generateNewChoice,
    questionsDefault,
    generateDefaultPage,
    generateSurveyTemplate,
} from "../../surveys";

const pages = [
    {
        ...generateDefaultPage(),
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["gridChoiceSingle"],
                headline:
                    "Overall, how would you rate the quality of your customer service experience?",
                choices: [
                    generateNewChoice("Very positive"),
                    generateNewChoice("Somewhat positive"),
                    generateNewChoice("Neutral"),
                    generateNewChoice("Somewhat negative"),
                    generateNewChoice("Very negative"),
                ],
                rows: [
                    generateNewChoice("Safety & Livability"),
                    generateNewChoice("Local Businesses"),
                    generateNewChoice("Dining & Farmers Market"),
                    generateNewChoice("Public Transit & Walkability"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "Overall, how would you rate the quality of your customer service experience?",
                choices: [
                    generateNewChoice("Very positive"),
                    generateNewChoice("Somewhat positive"),
                    generateNewChoice("Neutral"),
                    generateNewChoice("Somewhat negative"),
                    generateNewChoice("Very negative"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "How well did we understand your questions and concerns?",
                choices: [
                    generateNewChoice("Extremely well"),
                    generateNewChoice("Very well"),
                    generateNewChoice("Somewhat well"),
                    generateNewChoice("Not so well"),
                    generateNewChoice("Not at all well"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "How much time did it take us to address your questions and concerns?",
                choices: [
                    generateNewChoice("Much shorter than expected"),
                    generateNewChoice("Shorter than expected"),
                    generateNewChoice("About what I expected"),
                    generateNewChoice("Longer than expected"),
                    generateNewChoice("Much longer than expected"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["nps"],
                headline:
                    "How likely is it that you would recommend this company to a friend or colleague?",
                lowerLabel: "Not at all likely",
                upperLabel: "Extremely likely",
            },
            {
                id: uuidv4(),
                ...questionsDefault["openText"],
                headline:
                    "Do you have any other comments, questions, or concerns?",
                longAnswer: true,
            },
        ],
    },
];

export const customerServiceSurveyTemplate = generateSurveyTemplate({
    name: "Customer service survey",
    pages,
});
